import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { AlertCircle, ArrowRight, CheckCircle } from 'lucide-react';
export function HonestCaveatSlide() {
  return <SlideLayout slideNumber={15} totalSlides={20} title="Honest Assessment" data-id="element-274">
      <div className="w-full h-full flex flex-col" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-5" data-id="element-276">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-chip-gpu/10 text-chip-gpu text-lg font-medium mb-3" data-id="element-277">
            <AlertCircle size={20} data-id="element-278" />
            <span data-id="element-279">For Completeness</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-2" data-id="element-280">
            The Prefill <span className="text-chip-gpu" data-id="element-281">Limitation</span>
          </h2>
          <p className="text-2xl text-brand-muted max-w-3xl mx-auto" data-id="element-282">
            We believe in honest positioning. FPGAs are not the best at
            everything.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-brand-surface border border-chip-gpu/20 rounded-2xl p-7 mb-4" data-id="element-283">
          <h3 className="text-2xl font-bold text-chip-gpu mb-3" data-id="element-284">
            Where GPUs Still Lead
          </h3>
          <p className="text-brand-muted text-xl leading-relaxed" data-id="element-285">
            FPGAs are{' '}
            <span className="text-white font-semibold" data-id="element-286">
              inferior to GPUs during prefill
            </span>{' '}
            — the compute-intensive, high-parallelism phase of processing long
            input prompts. This is the matrix-matrix multiplication phase where
            GPU's massive parallelism genuinely shines.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-brand-surface border border-brand-primary/30 rounded-2xl p-7 mb-4 relative overflow-hidden" data-id="element-287">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-primary" data-id="element-288" />
          <h3 className="text-2xl font-bold text-brand-primary mb-4" data-id="element-289">
            The Hybrid Solution
          </h3>
          <div className="flex flex-col md:flex-row items-center gap-5" data-id="element-290">
            <div className="flex-1 text-center p-5 bg-chip-gpu/10 rounded-xl border border-chip-gpu/20" data-id="element-291">
              <div className="text-chip-gpu font-bold text-2xl mb-1" data-id="element-292">GPU</div>
              <div className="text-xl text-brand-muted" data-id="element-293">Prefill Phase</div>
              <div className="text-lg text-brand-muted mt-1" data-id="element-294">
                Long prompt processing
              </div>
            </div>
            <ArrowRight size={32} className="text-brand-muted shrink-0" data-id="element-295" />
            <div className="flex-1 text-center p-5 bg-brand-primary/10 rounded-xl border border-brand-primary/30" data-id="element-296">
              <div className="text-brand-primary font-bold text-2xl mb-1" data-id="element-297">
                FPGA
              </div>
              <div className="text-xl text-brand-muted" data-id="element-298">Decode Phase</div>
              <div className="text-lg text-brand-muted mt-1" data-id="element-299">
                Token generation
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-300">
          {[{
          label: 'Chatbots & Agents',
          desc: 'Autoregressive generation'
        }, {
          label: 'Streaming Inference',
          desc: 'Real-time token output'
        }, {
          label: 'Edge Deployment',
          desc: 'Low-power, low-latency'
        }].map(item => <div key={item.label} className="bg-brand-dark border border-brand-border rounded-xl p-4 flex items-start gap-3" data-id="element-301">
              <CheckCircle size={22} className="text-brand-primary shrink-0 mt-0.5" data-id="element-302" />
              <div data-id="element-303">
                <div className="text-xl font-bold text-white" data-id="element-304">{item.label}</div>
                <div className="text-lg text-brand-muted" data-id="element-305">{item.desc}</div>
              </div>
            </div>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="text-center text-xl text-brand-muted" data-id="element-306">
          For pure autoregressive generation workloads, the tradeoff{' '}
          <span className="text-brand-primary font-semibold" data-id="element-307">
            heavily favors FPGAs
          </span>
          . <span className="text-base opacity-60" data-id="element-308">[22][30]</span>
        </motion.p>
      </div>
    </SlideLayout>;
}